import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function ArticlePreview() {
  const { t } = useTranslation();

  return (
    <section id="article" className="relative py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
              {t("nav.guides")}
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-4">
              {t("article.title")}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-4 leading-relaxed">
              {t("article.subtitle")}
            </p>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6 line-clamp-4">
              {t("article.preview")}
            </p>
            <Link
              to="/artykul/kakobuy-spreadsheet-poradnik"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t("article.readmore")}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20desk%20setup%20with%20laptop%20showing%20fashion%20product%20grid%20and%20a%20notebook%2C%20surrounded%20by%20folded%20clothing%20items%20and%20a%20white%20coffee%20cup%2C%20warm%20morning%20sunlight%20through%20sheer%20curtains%2C%20soft%20oatmeal%20and%20sand%20tones%2C%20Scandinavian%20workspace%20aesthetic%2C%20cozy%20productive%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=article-preview-v3&orientation=landscape&nocache=true"
                alt="Kakobuy Spreadsheet poradnik"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}